import React from "react";

function Home() {
  return (
    <div className="page home">
      <h2>Welcome to <span className="highlight">GenZ Skills 🚀</span></h2>
      <p>
        We are on a mission to empower students with strong coding and
        problem-solving skills. Whether you’re just starting out or looking to
        sharpen your skills, we have something for you.
      </p>

      <div className="features">
        <div className="feature-card">
          <h3>💻 Coding Skills</h3>
          <p>Learn programming from scratch with hands-on projects and examples.</p>
        </div>
        <div className="feature-card">
          <h3>🧠 Problem Solving</h3>
          <p>Build logical thinking and problem-solving mindset to crack challenges.</p>
        </div>
        <div className="feature-card">
          <h3>🎓 Career Ready</h3>
          <p>Prepare for future jobs with real-world knowledge and practical exposure.</p>
        </div>
      </div>

      <div className="cta">
        <button className="btn-primary">Explore Courses</button>
        <button className="btn-secondary">Contact Us</button>
      </div>
    </div>
  );
}

export default Home;
